import React, { createContext, useState } from 'react';
import Header from '../Header/Header';
import { Outlet, useLoaderData } from 'react-router-dom';
import Footer from '../Footer/Footer';

export const QuizContext = createContext();

const Main = () => {
    const quizDta = useLoaderData([]);
    return (
        <QuizContext.Provider value={quizDta}>
            <Header></Header>
            <Outlet></Outlet>
            <Footer></Footer>
        </QuizContext.Provider>

    );
};

export default Main;